import React, { useEffect, useRef, useState } from "react";
import icon from '../images/icon-7.svg'

export const Onbarding = () => {
    const stepsRef = useRef(null);
    const width = window.innerWidth;
    const isMobile = width <= 800;

    const steps = [
        {
            number: '1',
            title: 'Defining Your Personal Brand',
            description: 'We start with a 90-minutes onboarding session to turn your ideas into a clear, structured plan. Before that, you’ll complete a short questionnaire to help us understand your journey, challenges, and strengths.',
            small: 'Positioning, Vision, Identity'
        },
        {
            number: '2',
            title: 'Data-Backed Marketing Pan',
            description: 'Next, we audit your last 90 days of content to understand what’s working for you, then build a structured marketing plan - all tailored to your goals and audience responses.',
            small: 'Insights, Strategy, Growth'
        },
        {
            number: '3',
            title: 'Crafting Content That Converts',
            description: 'We create highly impactful content by researching trends, pain points, and engagement patterns—ensuring every idea aligns with your brand’s voice and mission. From script to edit, we handle it all.',
            small: 'Creation, Engagement, Optimization'
        },
        {
            number: '4',
            title: 'Strategy Meets Smart Posting',
            description: 'We bring your brand to life with strategic execution—carefully scheduling your posts for maximum visibility and tracking performance to refine strategy, drive growth, and generate leads.',
            small: 'Planning, Visibility, Refinement'
        },
        {
            number: '5',
            title: 'From Automation To Conversion',
            description: 'In the first month, we analyze audience pain points and refine your strategy. Then we set up automation—managing your CRM and using email, WhatsApp, and Instagram to drive engagement and conversions.',
            small: 'Analysis, Nurturing, Conversion'
        }
    ];

    const [show, setShow] = useState(
        steps.map((step, index) => (
            <div
                key={index}
                className={`step ${index % 2 === 0 ? 'left' : 'right'}`}
            >
                <div
                    className={`single-process-column wow animate__animated ${index % 2 === 0 ? 'animate__fadeInLeft' : 'animate__fadeInRight'}`}
                    data-wow-duration="0.5s"
                    data-wow-delay="0.2s"
                >
                    <h4>{step.title} <span>{step.number}</span></h4>
                    <p>{step.description}</p>
                    <p><b>{step.small}</b></p>
                </div>
            </div>
        ))
    )

    useEffect(() => {
        const handleScroll = () => {
            if (!stepsRef.current) return;

            const stepsElement = stepsRef.current;
            const steps = stepsElement.querySelectorAll('.step');
            const progressLine = stepsElement.querySelector('.progress-line');
            const viewportHeight = window.innerHeight;
            const viewportMiddle = viewportHeight / 2;

            // Find the step closest to the middle of the viewport
            let currentStep = 0;
            let closestDistance = Infinity;

            steps.forEach((step, index) => {
                const rect = step.getBoundingClientRect();
                const stepMiddle = rect.top + (rect.height / 2);
                const distanceToMiddle = Math.abs(stepMiddle - viewportMiddle);

                if (distanceToMiddle < closestDistance) {
                    closestDistance = distanceToMiddle;
                    currentStep = index;
                }
            });

            // Calculate progress based on current step
            const progress = ((currentStep) / (steps.length - 1)) * 100;
            progressLine.style.height = `${progress}%`;
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Initial check

        if (isMobile) {
            setShow(
                steps.map((step, index) => (
                    <div
                        key={index}
                        className={`step ${index % 2 === 0 ? 'left' : 'right'}`}
                    >
                        <div
                            className="single-process-column wow animate__animated animate__fadeInRight"
                            data-wow-duration="0.5s"
                            data-wow-delay="0.2s"
                        >
                            <h4>{step.title} <span>{step.number}</span></h4>
                            <p>{step.description}</p>
                            <p><b>{step.small}</b></p>
                        </div>
                    </div>
                ))
            )
        }

        return () => window.removeEventListener('scroll', handleScroll);
    }, [isMobile]);

    return (
        <div className='onbarding' ref={stepsRef}>
            <div className="icon-7">
                <img src={icon} alt="" />
            </div>
            <div className="container">
                <h3
                // className="wow animate__animated animate__bounceInUp"
                // data-wow-duration="0.5s"
                // data-wow-delay="0.2s"
                >Our seamless <span>Scaling Process</span></h3>
                <p
                    className="title"
                // className='title wow animate__animated animate__bounceInUp'
                // data-wow-duration="0.5s"
                // data-wow-delay="0.3s"
                >
                    5 STEP PROCESS
                </p>

                <div className="main-steps">
                    <div className="progress-container">
                        <div className="progress-bg"></div>
                        <div className="progress-line"></div>
                    </div>

                    <div className="single-process-row">
                        {show}
                    </div>
                </div>
            </div>
        </div>
    )
}
